export default __webpack_public_path__ + "static/media/ic_andorra.148f885b.svg";